import { computed } from "mobx";
import Store from "./Store";
import Gemeente from "./Gemeente";
import { Geometry } from "geojson";
import Base from "./Base";

export default class VeiligheidsRegio extends Base {
  gemeentes: Gemeente[] = [];

  constructor(store: Store, feature: any) {
    super(store);
    this.type = "v";
    this.id = feature.properties.vid + "";
    this.name = feature.properties.statnaam;
    this.geometry = feature.geometry;
  }

  update() {
    let totals = new Array(this.store.dayCount).fill(0);
    this.gemeentes.forEach(g => {
      this.inhabitants += g.inhabitants;
      this.surface += g.surface;
      g.totals.forEach((t, n) => {
        totals[n] += t;
      });
    });
    this.calc(totals);
  }
}
